/*
 * サブシステム名：マスタ管理
 * 機能名：車両マスタ登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdHimodukeHaishahyoAddButton = () => import('@/components/DdHimodukeHaishahyoAddButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumberPlate = () => import('@/components/DdNumberPlate.vue')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdYearMonthBox = () => import('@/components/DdYearMonthBox.vue')

const RDDateBox = () => import('@/components/RDDateBox')
const RDDropDown = () => import('@/components/RDDropDown')
const RDNumericBox = () => import('@/components/RDNumericBox')
const RDTextBox = () => import('@/components/RDTextBox')
const RDYearMonthBox = () => import('@/components/RDYearMonthBox.vue')

export default {
  name: 'MstSharyoEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdHimodukeHaishahyoAddButton,
    DdIconButtonWithTooltip,
    DdNumberPlate,
    DdNumericBox,
    DdSectionTitle,
    DdSubHeader,
    DdTextArea,
    DdTextBox,
    DdYearMonthBox,
    RDDateBox,
    RDDropDown,
    RDNumericBox,
    RDTextBox,
    RDYearMonthBox
  },
  data: () => ({
    id: 0,
    copyMode: false,
    rec: {
      mstSharyo: {},
      haishahyoList: [{}]
    },
    invalidMessages: {},
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    headersNenpiCategoryList: header.mstNenpiCategoryHeaders,
    hacchusakiNm: '',
    hacchusakiNmShow: false,
    torokuNo: '',
    fuelKbnNm: '',
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false,
    // 初期カラー
    chipColorTmp: '',
    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    haishahyoInfoHeaders: [
      { text: 'ID', value: 'mstHaishaSharyoRelationId', align: ' d-none' },
      { text: '配車表コード', value: 'haishahyoCd', align: 'center', width: '10vw' },
      { text: '配車表表示名', value: 'haishahyoNm' },
      { text: '操作', value: 'actions', sortable: false, width: '5vw' }
    ],

    // 電子車検証
    isDragOver: false,
    denshiImportedLabel: '読込済み',
    denshiMismatchLabel: 'マスタ一致なし',
    importedShakenshoLabelInfo: {
      shataiBangou: '',
      shakenshoSbt: '',
      yukokikanManryoYmd1String: '',
      unyuKbn: '',
      torokuChimei: '',
      torokuBunruiNo: '',
      torokuHiragana: '',
      torokuIchirenShiteiNo: '',
      shonendoYm: '',
      kofuYmdString: '',
      yotoSbt: '',
      shakenshoJikayojigyouyoKbn: '',
      shamei: '',
      shataiKeijo: '',
      joshaTeiinNinzuu: '',
      saidaisekisaiRyo: '',
      sharyouJuryo: '',
      sharyouSoujuryo: '',
      nagasa: '',
      shakenshoHaba: '',
      takasa: '',
      ffJikujuu: '',
      frJikujuu: '',
      rfJikujuu: '',
      rrJikujuu: '',
      keishiki: '',
      gendokiKeishiki: '',
      haikiRyo: '',
      fuelKbn: '',
      keishikiShiteiNo: '',
      ruibetsuKbnNo: '',
      shoyushaShimei: '',
      shoyushaJusho: '',
      shiyoshaShimei: '',
      shiyoshaJusho: '',
      shiyoshaTelNo: '',
      shiyoshaHonkyo: '',
      shakenshoBiko: ''
    }
  }),
  watch: {
    'rec.mstSharyo.eigyoshoCd': function () {
      this.setHacchusaki()
    },
    'rec.mstSharyo.fuelKbn': function () {
      this.setFuelKbnNm()
    },
    'rec.mstSharyo.torokuChimei': function () {
      this.torokuNo = this.setTorokuNo()
    },
    'rec.mstSharyo.torokuBunruiNo': function () {
      this.torokuNo = this.setTorokuNo()
    },
    'rec.mstSharyo.torokuHiragana': function () {
      this.torokuNo = this.setTorokuNo()
    },
    'rec.mstSharyo.torokuIchirenShiteiNo': function () {
      this.torokuNo = this.setTorokuNo()
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      nenpiCategoryList: 'DDMasters/mstNenpiCategory',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 所属配車表一覧表示用
    filteredHaishahyoInfoRows () {
      return this.rec.haishahyoList
    },
    filteredTorihikisakiList () {
      // 発注先であるほうがいいけど、営業所の発注先コードのマッチングのためだけに
      // 使うから別にいいかな
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredHacchusakiEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.eigyoshoKbn === '03' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.tokuisakiHacchakuchiCd > elem2.tokuisakiHacchakuchiCd) { return 1 }
        if (elem1.tokuisakiHacchakuchiCd === elem2.tokuisakiHacchakuchiCd) { return 0 }
        return -1
      })
    },
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filteredFuelKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    filteredShashuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredUnyuKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF063')
    },
    filteredSharyoGroupSbt1 () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI012')
    },
    filteredSharyoGroupSbt2 () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI013')
    },
    filteredSharyoGroupSbt3 () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI016')
    },
    filteredSharyoGroupSbt4 () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI017')
    },
    filteredSharyoGroupSbt5 () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI018')
    },
    filteredUnchinShashuSbt  () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredShakenshoSbt  () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF023')
    },
    filteredYouto  () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF066')
    },
    filteredShakenshoJikayojigyouyoKbn  () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF067')
    },
    filteredNenpiCategory () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.nenpiCategoryList.map(elem => {
        return {
          value: elem.id,
          text: `${elem.nenpiCategoryCd}:${elem.nenpiCategoryNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    isDeleteDisable () {
      return this.id === 0
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    calcSuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoNumericLen) {
        return this.kihonJohoList[0].suryoNumericLen
      } else {
        return 10
      }
    },
    calcSuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoDecimalLen) {
        return this.kihonJohoList[0].suryoDecimalLen
      } else {
        return 4
      }
    },
    calcSuryoMax () {
      return Math.pow(10, this.calcSuryoIntegerDigit) - Math.pow(10, -1 * this.calcSuryoMinorDigit)
    },
    calcJuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoNumericLen) {
        return this.kihonJohoList[0].juryoNumericLen
      } else {
        return 10
      }
    },
    calcJuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoDecimalLen) {
        return this.kihonJohoList[0].juryoDecimalLen
      } else {
        return 4
      }
    },
    calcJuryoMax () {
      return Math.pow(10, this.calcJuryoIntegerDigit) - Math.pow(10, -1 * this.calcJuryoMinorDigit)
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    setTorokuNo: function () {
      var torokuNoList = []
      if (this.rec.mstSharyo.torokuChimei) {
        torokuNoList.push(this.rec.mstSharyo.torokuChimei)
      }
      if (this.rec.mstSharyo.torokuBunruiNo) {
        torokuNoList.push(this.rec.mstSharyo.torokuBunruiNo)
      }
      if (this.rec.mstSharyo.torokuHiragana) {
        torokuNoList.push(this.rec.mstSharyo.torokuHiragana)
      }
      if (this.rec.mstSharyo.torokuIchirenShiteiNo) {
        torokuNoList.push(this.rec.mstSharyo.torokuIchirenShiteiNo)
      }
      return torokuNoList.join('　')
    },
    setHacchusaki: function () {
      this.hacchusakiNm = ''
      this.hacchusakiNmShow = false
      this.rec.mstSharyo.hacchusakiflg = false
      // todo:2021/02/12_QA待ちのため、暫定で営業所選択時の発注先CDを設定。
      this.rec.mstSharyo.hacchusakiCd = ''

      var hacchusakiEigyosho = this.filteredHacchusakiEigyoshoList.filter((elem) => {
        return elem.eigyoshoCd === this.rec.mstSharyo.eigyoshoCd
      })
      if (hacchusakiEigyosho.length !== 0) {
        this.hacchusakiNmShow = true
        this.rec.mstSharyo.hacchusakiflg = true
        var hacchusaki = this.filteredTorihikisakiList.filter((elem) => {
          return elem.torihikisakiCd === hacchusakiEigyosho[0].hacchusakiCd
        })
        if (hacchusaki.length !== 0) {
          this.hacchusakiNm = hacchusaki[0].torihikisakiNm
          this.rec.mstSharyo.hacchusakiCd = hacchusaki[0].torihikisakiCd
        }
      }
    },
    setFuelKbnNm: function () {
      var result = this.filteredFuelKbn.filter((elem) => {
        return elem.code === this.rec.mstSharyo.fuelKbn
      })
      if (result.length !== 0) {
        this.fuelKbnNm = result[0].codeNm
      } else {
        this.fuelKbnNm = ''
      }
    },
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/D2mstd0040/find?id=${this.id}`)
          .then((data) => {
            this.rec.mstSharyo = data.payload.mstSharyo
            // 日付項目を削除（日付文字列化項目を使用）
            delete this.rec.mstSharyo.nextShakenYmd
            delete this.rec.mstSharyo.nextOilYmd
            delete this.rec.mstSharyo.konyuYmd
            delete this.rec.mstSharyo.leaseEndYmd
            delete this.rec.mstSharyo.haishaYmd
            delete this.rec.mstSharyo.kofuYmd
            delete this.rec.mstSharyo.yukokikanManryoYmd1
            delete this.rec.mstSharyo.yukokikanManryoYmd2
            delete this.rec.mstSharyo.tekiyoStartYmd
            delete this.rec.mstSharyo.tekiyoEndYmd

            // nullを置き換え
            this.$set(this.rec.mstSharyo, 'hacchusakiCd', data.payload.mstSharyo.hacchusakiCd)
            // this.rec.mstSharyo.shashuSbt = this.rec.mstSharyo.shashuSbt ? this.rec.mstSharyo.shashuSbt : null
            // this.rec.mstSharyo.unyuKbn = this.rec.mstSharyo.unyuKbn ? this.rec.mstSharyo.unyuKbn : null
            // this.rec.mstSharyo.sharyoGroupSbt1 = this.rec.mstSharyo.sharyoGroupSbt1 ? this.rec.mstSharyo.sharyoGroupSbt1 : null
            // this.rec.mstSharyo.sharyoGroupSbt2 = this.rec.mstSharyo.sharyoGroupSbt2 ? this.rec.mstSharyo.sharyoGroupSbt2 : null
            // this.rec.mstSharyo.sharyoGroupSbt3 = this.rec.mstSharyo.sharyoGroupSbt3 ? this.rec.mstSharyo.sharyoGroupSbt3 : null
            // this.rec.mstSharyo.sharyoGroupSbt4 = this.rec.mstSharyo.sharyoGroupSbt4 ? this.rec.mstSharyo.sharyoGroupSbt4 : null
            // this.rec.mstSharyo.sharyoGroupSbt5 = this.rec.mstSharyo.sharyoGroupSbt5 ? this.rec.mstSharyo.sharyoGroupSbt5 : null
            // this.rec.mstSharyo.unchinShashuSbt = this.rec.mstSharyo.unchinShashuSbt ? this.rec.mstSharyo.unchinShashuSbt : null
            // this.rec.mstSharyo.shakenshoSbt = this.rec.mstSharyo.shakenshoSbt ? this.rec.mstSharyo.shakenshoSbt : null
            // this.rec.mstSharyo.yotoSbt = this.rec.mstSharyo.yotoSbt ? this.rec.mstSharyo.yotoSbt : null
            // this.rec.mstSharyo.shakenshoJikayojigyouyoKbn = this.rec.mstSharyo.shakenshoJikayojigyouyoKbn ? this.rec.mstSharyo.shakenshoJikayojigyouyoKbn : null
            this.rec.mstSharyo.nextShakenYmdString = this.rec.mstSharyo.nextShakenYmdString ? this.rec.mstSharyo.nextShakenYmdString : ''
            this.rec.mstSharyo.nextOilYmdString = this.rec.mstSharyo.nextOilYmdString ? this.rec.mstSharyo.nextOilYmdString : ''
            this.rec.mstSharyo.konyuYmdString = this.rec.mstSharyo.konyuYmdString ? this.rec.mstSharyo.konyuYmdString : ''
            this.rec.mstSharyo.leaseEndYmdString = this.rec.mstSharyo.leaseEndYmdString ? this.rec.mstSharyo.leaseEndYmdString : ''
            this.rec.mstSharyo.haishaYmdString = this.rec.mstSharyo.haishaYmdString ? this.rec.mstSharyo.haishaYmdString : ''
            this.rec.mstSharyo.kofuYmdString = this.rec.mstSharyo.kofuYmdString ? this.rec.mstSharyo.kofuYmdString : ''
            this.rec.mstSharyo.yukokikanManryoYmd1String = this.rec.mstSharyo.yukokikanManryoYmd1String ? this.rec.mstSharyo.yukokikanManryoYmd1String : ''
            this.rec.mstSharyo.yukokikanManryoYmd2String = this.rec.mstSharyo.yukokikanManryoYmd2String ? this.rec.mstSharyo.yukokikanManryoYmd2String : ''
            this.rec.mstSharyo.tekiyoStartYmdString = this.rec.mstSharyo.tekiyoStartYmdString ? this.rec.mstSharyo.tekiyoStartYmdString : ''
            this.rec.mstSharyo.tekiyoEndYmdString = this.rec.mstSharyo.tekiyoEndYmdString ? this.rec.mstSharyo.tekiyoEndYmdString : ''
            this.rec.mstSharyo.color = [undefined, null, ''].includes(this.rec.mstSharyo.color) ? '#b0bec5' : this.rec.mstSharyo.color

            this.chipColorTmp = this.rec.mstSharyo.color

            if (data.payload.haishahyoList) {
              var p = data.payload.haishahyoList
              for (let i = 0; i < p.length; i++) {
                const res = {}
                res.mstHaishaSharyoRelationId = p[i].mstHaishaSharyoRelationId
                res.delFlg = p[i].delFlg
                res.haishahyoCd = p[i].haishahyoCd
                res.haishahyoNm = p[i].haishahyoNm
                if (this.rec.haishahyoList.length > 0) {
                  this.rec.haishahyoList.push(res)
                } else {
                  this.rec.haishahyoList = [res]
                }
              }
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('★★★initialize★★★')
      const self = this
      const option = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'vwcmsteigyoshojininlist', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun', 'mstkihonjoho', 'mstnenpicategory'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec.mstSharyo = {
              sharyoNo: '',
              jidoshaHyojiNm: '',
              eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              jomuinCd: '',
              fuelKbn: '',
              workDay: '25',
              shashuSbt: null,
              unyuKbn: null,
              mstNenpiCategoryId: null,
              etcNo: '',
              torokuChimei: '',
              torokuBunruiNo: '',
              torokuHiragana: '',
              torokuIchirenShiteiNo: '',
              sharyoGroupSbt1: null,
              sharyoGroupSbt2: null,
              sharyoGroupSbt3: null,
              sharyoGroupSbt4: null,
              sharyoGroupSbt5: null,
              nenpi: '',
              tokuisakiHacchakuchiCd: '',
              tokuisakiHinmeiCd: '',
              unchinShashuSbt: null,
              unchinSharyoSize: '',
              nextShakenYmdString: '',
              nextOilYmdString: '',
              konyuYmdString: '',
              leaseEndYmdString: '',
              yoteiShiyoNensu: '',
              haishaYmdString: '',
              konyuKakaku: '',
              shutokuZeiKingaku: '',
              torokuTesuryo: '',
              jidoshaZeiKingaku: '',
              juryoZei: '',
              shakenKingakuMonth: '',
              jibaisekiHokenKingaku: '',
              taiyaKeihiKingakuMonth: '',
              leaseShoukyaku: '',
              sharyoHokenKingaku: '',
              taijinHokenKingaku: '',
              taibutsuHokenKingaku: '',
              kamotsuHokenKingaku: '',
              hokenKaisha: '',
              digitakoRenkeiText1: '',
              digitakoRenkeiText2: '',
              gaibuRenkeiyoText1: '',
              gaibuRenkeiyoText2: '',
              kofuYmdString: '',
              shonendoYm: '',
              shakenshoSbt: null,
              yotoSbt: null,
              shakenshoJikayojigyouyoKbn: null,
              shataiKeijo: '',
              shamei: '',
              joshaTeiinNinzuu: '',
              saidaisekisaiRyo: '',
              sharyouJuryo: '',
              sharyouSoujuryo: '',
              shataiBangou: '',
              nagasa: '',
              shakenshoHaba: '',
              takasa: '',
              ffJikujuu: '',
              frJikujuu: '',
              rfJikujuu: '',
              rrJikujuu: '',
              keishiki: '',
              gendokiKeishiki: '',
              haikiRyo: '',
              keishikiShiteiNo: '',
              ruibetsuKbnNo: '',
              shoyushaShimei: '',
              shoyushaJusho: '',
              shiyoshaShimei: '',
              shiyoshaJusho: '',
              shiyoshaHonkyo: '',
              yukokikanManryoYmd1String: '',
              yukokikanManryoYmd2String: '',
              shakenshoBiko: '',
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              hyojiOrder: 9999,
              hacchusakiFlg: false,
              hacchusakiCd: '',
              color: '#496801'
            }
            self.chipColorTmp = self.rec.mstSharyo.color
            this.rec.haishahyoList = []
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★★★savedInputRestorePromise★★★', c)
            self.rec.mstSharyo = {
              ...self.rec.mstSharyo,
              fuelKbn: [undefined, null, ''].includes(c.fuelKbn) ? null : c.fuelKbn,
              unyuKbn: [undefined, null, ''].includes(c.unyuKbn) ? null : c.unyuKbn,
              shakenshoSbt: [undefined, null, ''].includes(c.shakenshoSbt) ? null : c.shakenshoSbt
            }
            console.log('★savedInputRestorePromise', self.rec.mstSharyo)
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('★★★existsIdMethod★★★', self.id)
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★')
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            console.log('■restoreInputsPromise', data())
            self.rec = data()
            self.rec.mstSharyo.id = self.id
            // 複写後のキャンセル押下で車両コードが残りエラーとなるため、id=0の場合は車両コードを空にする
            if (self.rec.mstSharyo.id === 0) { self.rec.mstSharyo.sharyoCd = '' }
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.HttpClient.post('/api/v1/D2mstd0040/Delete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.mstSharyo.id = 0
          // 自動採番のため複写対象としない
          self.rec.mstSharyo.sharyoCd = ''
          self.rec.haishahyoList = self.rec.haishahyoList.map((elem) => {
            elem.mstHaishaSharyoRelationId = -1
            return elem
          })
          self.modeOfEdit = 0
          self.copyMode = true
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.mstSharyo.id
            self.copyMode = false
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★★★getSavedInputMethod', self.rec.mstSharyo.fuelKbn, self.rec.mstSharyo.unyuKbn, self.rec.mstSharyo.shakenshoSbt)
          return {
            fuelKbn: self.rec.mstSharyo.fuelKbn,
            unyuKbn: self.rec.mstSharyo.unyuKbn,
            shakenshoSbt: self.rec.mstSharyo.shakenshoSbt
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      const f = this.HttpClient.post('/api/v1/D2mstd0040/Create', this.rec)
      return f
    },
    registerValidate: function () {
      var msg = validators.numericalRangeValidate({ value: this.rec.mstSharyo.workDay, max: 31, min: 1 })
      if (msg !== undefined) {
        this.$refs.workDay[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      msg = validators.compareDate(this.rec.mstSharyo.tekiyoStartYmdString, this.rec.mstSharyo.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    },
    deleteValidate: function () {
      return true
    },
    rowColorClass: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    himodukeHaishahyoAddSync: function (p) {
      if (this.isShoukaiMode === true) { return }
      console.log(' **** XXXXX **** kamotsuHimodukeNippoSearchSync', p)
      for (let i = 0; i < p.length; i++) {
        const res = {}
        res.mstHaishaSharyoRelationId = -1
        res.delFlg = false
        res.haishahyoCd = p[i].haishahyoCd
        res.haishahyoNm = p[i].haishahyoNm

        if (this.rec.haishahyoList.length > 0) {
          this.rec.haishahyoList.push(res)
        } else {
          this.rec.haishahyoList = [res]
        }
      }
    },
    onHaishahyoHimodukeDeleteButtonClick: function (item) {
      if (this.isShoukaiMode === true) { return }
      const index = this.rec.haishahyoList.indexOf(item)
      var row = Object.assign({}, item)
      row.delFlg = !row.delFlg
      Object.assign(this.rec.haishahyoList[index], row)
    },
    onUndoChipColor: function () {
      this.rec.mstSharyo.color = this.chipColorTmp
    },
    syncJidoshaHyojiNm: function () {
      this.rec.mstSharyo.jidoshaHyojiNm = this.rec.mstSharyo.torokuChimei + this.rec.mstSharyo.torokuBunruiNo + this.rec.mstSharyo.torokuHiragana + this.rec.mstSharyo.torokuIchirenShiteiNo
    },
    // 電子車検証
    onFileSelected: function (e) {
      // 電子車検証読込済みラベル初期化
      this.initializeObject(this.importedShakenshoLabelInfo)

      const files = e.target.files
      if (files === undefined || files === null) {
        modals.showToast('電子車検証の読み込みに失敗しました', null, 400, null, 'error')
        return
      }
      files.forEach((file) => {
        if (file.type !== 'application/json') {
          modals.showToast('電子車検証の読み込みに失敗しました', null, 400, null, 'error')
          return
        }
        const fr = new FileReader()
        fr.readAsText(file, 'utf-8')
        fr.addEventListener('load', () => {
          var isValid = false
          try {
            const json = JSON.parse(fr.result)
            if (this.setDenshiShakenshoInfo(json)) {
              isValid = true
            }
          } catch (error) {
          }
          if (isValid) {
            modals.showToast('電子車検証の読み込みに成功しました', null, 400, null, 'info')
          } else {
            modals.showToast('電子車検証の読み込みに失敗しました', null, 400, null, 'error')
          }
        })
      })
      // ファイルオブジェクトの値を削除
      const input = this.$el.querySelector('#file-input-denshi')
      if (input) { input.value = '' }
    },
    setDenshiShakenshoInfo: function (json) {
      console.log('電子車検証', json)
      const certInfo = json.CertInfo
      if (!certInfo) { return false }
      // ■車台番号
      this.setDenshiShakensho('shataiBangou', certInfo.TwodimensionCodeInfoCarNo)
      // ■自動車種別 ※文字間の全角スペースを除去
      this.setDenshiShakenshoForSbt('shakenshoSbt', certInfo.CarKind?.replace(/\s+/g, ''), 'SFF023')
      // ■有効期限
      this.setDenshiShakenshoForYmd('yukokikanManryoYmd1String', certInfo.ValidPeriodExpirdateE, certInfo.ValidPeriodExpirdateY, certInfo.ValidPeriodExpirdateM, certInfo.ValidPeriodExpirdateD)
      // ■運輸支局等
      this.setDenshiShakenshoForUnyuKbn('unyuKbn', certInfo.TranspotationBureauchiefName, 'SFF063')
      if (certInfo.TwodimensionCodeInfoEntryNoCarNo) {
        // ■地名
        this.setDenshiShakensho('torokuChimei', certInfo.TwodimensionCodeInfoEntryNoCarNo?.slice(0, 4).trim())
        // ■分類番号
        this.setDenshiShakensho('torokuBunruiNo', certInfo.TwodimensionCodeInfoEntryNoCarNo?.slice(4, 7).normalize('NFKC').trim())
        // ■記号
        this.setDenshiShakensho('torokuHiragana', certInfo.TwodimensionCodeInfoEntryNoCarNo?.slice(7, 8).trim())
        // ■番号
        this.setDenshiShakensho('torokuIchirenShiteiNo', certInfo.TwodimensionCodeInfoEntryNoCarNo?.slice(8, 12).normalize('NFKC').trim())
      }
      // ■初度登録年月
      this.setDenshiShakenshoForYm('shonendoYm', certInfo.FirstregistdateE, certInfo.FirstregistdateY, certInfo.FirstregistdateM)
      // ■登録年月日／交付年月日
      this.setDenshiShakenshoForYmd('kofuYmdString', certInfo.ReggrantdateE, certInfo.ReggrantdateY, certInfo.ReggrantdateM, certInfo.ReggrantdateD)
      // ■用途
      this.setDenshiShakenshoForSbt('yotoSbt', certInfo.Use, 'SFF066')
      // ■自家用・事業用の別
      this.setDenshiShakenshoForSbt('shakenshoJikayojigyouyoKbn', certInfo.PrivateBusiness, 'SFF067')
      // ■車名
      this.setDenshiShakensho('shamei', certInfo.CarName)
      // ■車体の形状
      this.setDenshiShakensho('shataiKeijo', certInfo.CarShape)
      // ■乗車定員(人)
      this.setDenshiShakenshoForNumber('joshaTeiinNinzuu', certInfo.Cap)
      // ■最大積載量(kg)
      this.setDenshiShakenshoForNumber('saidaisekisaiRyo', certInfo.Maxloadage)
      // ■車両重量(kg)
      this.setDenshiShakenshoForNumber('sharyouJuryo', certInfo.CarWgt)
      // ■車両総重量(kg)
      this.setDenshiShakenshoForNumber('sharyouSoujuryo', certInfo.CarTotalWgt)
      // ■長さ(cm)
      this.setDenshiShakenshoForNumber('nagasa', certInfo.Length)
      // ■幅(cm)
      this.setDenshiShakenshoForNumber('shakenshoHaba', certInfo.Width)
      // ■高さ(cm)
      this.setDenshiShakenshoForNumber('takasa', certInfo.Height)
      // ■前前軸重(kg)
      this.setDenshiShakenshoForNumber('ffJikujuu', certInfo.FfAxWgt)
      // ■前後軸重(kg)
      this.setDenshiShakenshoForNumber('frJikujuu', certInfo.FrAxWgt)
      // ■後前軸重(kg)
      this.setDenshiShakenshoForNumber('rfJikujuu', certInfo.RfAxWgt)
      // ■後後軸重(kg)
      this.setDenshiShakenshoForNumber('rrJikujuu', certInfo.RrAxWgt)
      // ■型式
      this.setDenshiShakensho('keishiki', certInfo.TwodimensionCodeInfoModel)
      // ■原動機の型式
      this.setDenshiShakensho('gendokiKeishiki', certInfo.TwodimensionCodeInfoEngineModel)
      // ■総排気量又は定格出力
      this.setDenshiShakenshoForNumber('haikiRyo', certInfo.Displacement)
      // ■燃料の種類
      this.setDenshiShakenshoForKbn('fuelKbn', certInfo.FuelClass, 'SFF053')
      // ■型式指定番号
      this.setDenshiShakensho('keishikiShiteiNo', certInfo.ModelSpecifyNo)
      // ■類別区分番号
      this.setDenshiShakensho('ruibetsuKbnNo', certInfo.ClassifyAroundNo)
      // ■氏名 所有者/使用者
      this.setDenshiShakensho('shoyushaShimei', certInfo.OwnernameHighLevelChar)
      if (certInfo.UsernameHighLevelChar === '＊＊＊') {
        // 同上
        this.setDenshiShakensho('shiyoshaShimei', this.rec.mstSharyo.shoyushaShimei)
      } else {
        this.setDenshiShakensho('shiyoshaShimei', certInfo.UsernameHighLevelChar)
      }
      // ■住所 所有者/使用者/使用者本拠
      this.setDenshiShakensho('shoyushaJusho', `${certInfo.OwnerAddressChar}${certInfo.OwnerAddressNumValue}`)
      if (certInfo.OwnerAddressChar === '＊＊＊') {
        // 同上
        this.setDenshiShakensho('shiyoshaJusho', this.rec.mstSharyo.shoyushaJusho)
      } else {
        this.setDenshiShakensho('shiyoshaJusho', `${certInfo.UserAddressChar}${certInfo.UserAddressNumValue}`)
      }
      if (certInfo.UseheadqrterChar === '＊＊＊') {
        // 同上
        this.setDenshiShakensho('shiyoshaHonkyo', this.rec.mstSharyo.shiyoshaJusho)
      } else {
        this.setDenshiShakensho('shiyoshaHonkyo', `${certInfo.UseheadqrterChar}${certInfo.UseheadqrterNumValue}`)
      }
      // ■備考
      this.setDenshiShakensho('shakenshoBiko', certInfo.NoteInfo)
      /*
       * 対応項目なし
       */
      // ■使用者の電話番号
      // row.shiyoshaTelNo
      return true
    },
    setDenshiShakensho: function (name, value) {
      if (value) { this.setDenshiShakenshoValue(name, value) }
    },
    setDenshiShakenshoForNumber: function (name, value) {
      if (value && !isNaN(value)) { this.setDenshiShakenshoValue(name, value) }
    },
    setDenshiShakenshoForYmd: function (name, gengo, gengoYear, month, day) {
      const value = this.convertGengoToYYYYMMDD(gengo, gengoYear, month, day)
      if (value) { this.setDenshiShakenshoValue(name, value) }
    },
    setDenshiShakenshoForYm: function (name, gengo, gengoYear, month) {
      const value = this.convertGengoToYYYYMM(gengo, gengoYear, month)
      if (value) { this.setDenshiShakenshoValue(name, value) }
    },
    setDenshiShakenshoForKbn: function (name, value, shuruiCd) {
      const list = this.kubunListFilter(this.kubunList, shuruiCd) || []
      const code = list.find(item => item.codeNm === value)?.code
      if (code) {
        this.setDenshiShakenshoValue(name, code)
      } else if (value) {
        this.importedShakenshoLabelInfo[name] = this.denshiMismatchLabel
      }
    },
    setDenshiShakenshoForSbt: function (name, value, shuruiCd) {
      const list = this.sbtListFilter(this.shubetsuList, shuruiCd) || []
      const code = list.find(item => item.sbtNm === value)?.sbtCd
      if (code) {
        this.setDenshiShakenshoValue(name, code)
      } else if (value) {
        this.importedShakenshoLabelInfo[name] = this.denshiMismatchLabel
      }
    },
    setDenshiShakenshoForUnyuKbn: function (name, value, shuruiCd) {
      const list = this.kubunListFilter(this.kubunList, shuruiCd) || []
      var code = list.find(item => item.codeNm === value)?.code
      if (!code) {
        // 「〇〇運輸支局長」という文字列で来ることがあるので、それ対策
        const match = value.match(/.*運輸支局/)
        code = list.find(item => item.codeNm === (match ? match[0] : ''))?.code
      }
      if (code) {
        this.setDenshiShakenshoValue(name, code)
      } else if (value) {
        this.importedShakenshoLabelInfo[name] = this.denshiMismatchLabel
      }
    },
    setDenshiShakenshoValue: function (name, value) {
      this.rec.mstSharyo[name] = value
      this.importedShakenshoLabelInfo[name] = this.denshiImportedLabel
    },
    getImportedLabel: function (name) {
      return this.importedShakenshoLabelInfo[name]
    },
    initializeObject: function (obj) {
      Object.keys(obj).forEach(key => {
        obj[key] = ''
      })
    },
    // 元号が増える度メンテして
    convertGengoToYYYYMM: function (gengo, gengouYear, month) {
      const eraMap = [
        { gengo: '令和', year: 2019 },
        { gengo: '平成', year: 1989 },
        { gengo: '昭和', year: 1926 },
        { gengo: '大正', year: 1912 },
        { gengo: '明治', year: 1868 }
      ]

      var target = eraMap.find(item => item.gengo === gengo?.trim())
      if (!target) { return null }

      // 元号の開始年に元号の年を加算（1年を考慮）
      const year = target.year + Number(gengouYear?.trim()) - 1
      // 月を2桁にする
      const formattedMonth = String(month?.trim()).padStart(2, '0')

      return `${year}/${formattedMonth}`
    },
    convertGengoToYYYYMMDD: function (gengo, gengouYear, month, day) {
      const yyyyMM = this.convertGengoToYYYYMM(gengo, gengouYear, month)
      if (!yyyyMM) { return null }
      const formattedDay = String(day?.trim()).padStart(2, '0')
      return `${yyyyMM}/${formattedDay}`
    }
  }
}
